import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Grid, Dialog, DialogContent } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import CustomDialog from "../commoncomponents/CustomDialog";
import Axios from 'axios';
import { DefaultCard } from "../../assets/styled-components/card";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import PageTitle from "../commoncomponents/PageTitle";
import { MasterGraph, FemsGraph, BemsGraph, ifacSecurityURL } from "../../utility/apiURLS";
import { getAuthToken, getcompanyId, getFacilityId } from "../../utility/tokenUtility";
import Kpirepairdownload from './Kpirepairdownload';
import DownloadIcon from '@mui/icons-material/Download';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
import * as XLSX from 'xlsx';
const Kpirepairviewfile = () => {
    const navigate = useNavigate();
    const [service, setService] = useState("");
    const [hospitalname, setHospitalname] = useState("");
    const [serviceOptions, setServiceOptions] = useState([]);
    const [reportdata, setReportdata] = useState([]);
    const [errors, setErrors] = useState({});
    const [errorMessages, setErrorMessages] = useState({});
    const [year, setYear] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [hospitalnameOptions, setHospitalnameOptions] = useState([]);
    const token = getAuthToken("id_token");
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [isView, setIsView] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const [text, setText] = useState("");
    const [date, setDate] = useState("");
    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "ENGA009B");

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const userId = localStorage.getItem('UserId');
    const companyId = getcompanyId("companyId");
    const facilityId = localStorage.getItem('facilityId');
    const handleCancel = () => {
        if (!service || !year || !hospitalnameOptions) {
            navigate("/dashboard");
            dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
            dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
        } else {
            setCancelDialogOpen(true);
        }

    };
    const handlehospital = (newValue) => {
        if (newValue) {
            setHospitalname(newValue?.value || "");
            setHospitalname(newValue);
            setErrors((prevErrors) => ({ ...prevErrors, hospitalname: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, hospitalname: "" }));
            setText("");  // Reset text when hospital changes
            setDate("");  // Reset date when hospital changes

        }
    };

    const handleServiceChange = (newValue) => {
        setService(newValue?.value || "");
        if (newValue) {
            setErrors((prevErrors) => ({ ...prevErrors, service: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, service: "" }));
            setText("");  // Reset text when hospital changes
            setDate("");  // Reset date when hospital changes
        }
    };
    const handleYearChange = (newValue) => {
        setYear(newValue?.value || "");
        if (newValue) {
            setErrors((prevErrors) => ({ ...prevErrors, year: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, year: "" }));
            setText("");  // Reset text when hospital changes
            setDate("");  // Reset date when hospital changes
        }
    };




    const fetchServiceOptions = async () => {
        try {
            const response = await Axios.get(`${MasterGraph}/api/masservicedetails`, config);

            const filteredOptions = response.data
                .filter(option => option.service)
                .map(option => ({
                    label: option.service,
                    value: option.service,
                    id: option.id
                }));

            // Add "All" option at the beginning
            const withAllOption = [
                { label: "All", value: "All", id: "all" },
                ...filteredOptions
            ];

            setServiceOptions(withAllOption);

        } catch (error) {
            console.error("Error fetching service options:", error);
        }
    };

    const fetchHospitalName = async () => {
        try {
            const response = await Axios.get(`${ifacSecurityURL}/api/GraphUserdetails/GetAllFacilityDetailsByCompanyIdAndUserId/${companyId}/${userId}`, config);

            if (response.data && Array.isArray(response.data)) {
                const options = response.data.map((hn) => ({
                    label: hn.facilityName,
                    id: hn.facilityId,
                }));
                setHospitalnameOptions(options);
            }
        } catch (error) {
            console.error("Error fetching hospital names:", error);
        }
    };



    const fetchReportdata = async () => {
        try {
            let response;
            if (service === "FEMS") {
                response = await Axios.get(
                    `${FemsGraph}/api/KPIScheduleReport/GetKPIScheduleReport/${year}/${hospitalname.id}?size=1000`,
                    config
                );
                const reportdata = Array.isArray(response.data) ? response.data[0] : response.data;
                setReportdata(reportdata);

            } else if (service === "BEMS") {
                response = await Axios.get(
                    `${BemsGraph}/api/KPIScheduleReport/GetKPIScheduleReport/${year}/${hospitalname.id}?size=1000`,
                    config
                );
                const reportdata = Array.isArray(response.data) ? response.data[0] : response.data;
                setReportdata(reportdata);

            } else if (service === "All") {
                // fetch both in parallel
                const [femsRes, bemsRes] = await Promise.all([
                    Axios.get(
                        `${FemsGraph}/api/KPIScheduleReport/GetKPIScheduleReport/${year}/${hospitalname.id}?size=1000`,
                        config
                    ),
                    Axios.get(
                        `${BemsGraph}/api/KPIScheduleReport/GetKPIScheduleReport/${year}/${hospitalname.id}?size=1000`,
                        config
                    )
                ]);

                const femsData = Array.isArray(femsRes.data) ? femsRes.data[0] : femsRes.data;
                const bemsData = Array.isArray(bemsRes.data) ? bemsRes.data[0] : bemsRes.data;

                const months = [
                    "Jan", "Feb", "March", "April", "May", "June", "July",
                    "August", "Sept", "Oct", "Nov", "Dec", "Total"
                ];

                let combinedData = {};

                months.forEach((m) => {
                    const nuKey = `nu${m}`;
                    const deKey = `de${m}`;
                    const perKey = `per${m}`;

                    const nu = (femsData?.[nuKey] || 0) + (bemsData?.[nuKey] || 0);
                    const de = (femsData?.[deKey] || 0) + (bemsData?.[deKey] || 0);

                    let per = "0%";

                    if (de > 0) {
                        // calculate based on numerator/denominator
                        per = ((nu / de) * 100).toFixed(2) + "%";
                    } else {
                        // fallback: average percentage if denominator is missing
                        const femsPer = femsData?.[perKey] ? parseFloat(femsData[perKey]) : 0;
                        const bemsPer = bemsData?.[perKey] ? parseFloat(bemsData[perKey]) : 0;
                        per = ((femsPer + bemsPer) / 2).toFixed(2) + "%";
                    }

                    combinedData[nuKey] = nu;
                    combinedData[deKey] = de;
                    combinedData[perKey] = per;
                });

                setReportdata(combinedData);
            } else {
                return;
            }
        } catch (error) {
            console.error("Error fetching report data:", error);
        }
    };


    useEffect(() => {
        fetchServiceOptions();
        fetchHospitalName();
    }, []);
    const handleView = async () => {
        setIsView(true);

        if (!service || !year || !hospitalname) {
            setErrors({
                service: !service,
                year: !year,
                hospitalname: !hospitalname,
            });
            setErrorMessages({
                service: !service ? "Service is required" : "",
                year: !year ? "Year is required" : "",
                hospitalname: !hospitalname ? "Hospital Name is required" : "",
            });
            return;
        }

        try {
            await fetchReportdata();

            setOpenModal(true);
        } catch (error) {


        }
    };

    const handleCancelConfirm = () => {
        setCancelDialogOpen(false);
        navigate("/dashboard");
        dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
        dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
    };
    const handleCancelDialogClose = () => {
        setCancelDialogOpen(false);
    };


    const handleDownload = async () => {

        if (!service || !year || !hospitalname) {
            setErrors({
                service: !service,
                year: !year,
                hospitalname: !hospitalname,
            });
            setErrorMessages({
                service: !service ? "Service is required" : "",
                year: !year ? "Year is required" : "",
                hospitalname: !hospitalname ? "Hospital Name is required" : "",
            });
            return;
        }

        await fetchReportdata();
        setIsView(false);
        setOpenModal(true);


        setTimeout(() => {
            if (childRef.current) {
                childRef.current.handleDownloadPDF();
            }

            setTimeout(() => {
                setOpenModal(false);
            }, 1000);
        }, 500);


    };

    const handleExcel = async () => {

        if (!service || !year || !hospitalname) {
            setErrors({
                service: !service,
                year: !year,
                hospitalname: !hospitalname,
            });
            setErrorMessages({
                service: !service ? "Service is required" : "",
                year: !year ? "Year is required" : "",
                hospitalname: !hospitalname ? "Hospital Name is required" : "",
            });
            return;
        }

        await fetchReportdata();
        setIsView(false);
        setOpenModal(true);


        setTimeout(() => {
            if (childRef.current) {
                childRef.current.handleExcel();
            }

            setTimeout(() => {
                setOpenModal(false);
            }, 1000);
        }, 500);


    };

    return (
        <>
            <PageTitle title={"KPI Repair  Time Report"} />

            <Box mt={{ xs: 1, sm: 2 }}>
                <DefaultCard>
                    <Grid container spacing={2}>

                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Hospital Name"
                                id="hospital-name"
                                autoFocus={true}
                                value={hospitalname || null}
                                options={hospitalnameOptions}
                                onChange={handlehospital}
                                isMandatoryField={true}
                                error={errors.hospitalname}
                                errorMessage={errorMessages.hospitalname}
                            />

                        </Grid>
                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                id="service-label"
                                label="Service"

                                value={serviceOptions.find(option => option.value === service) || null}
                                options={serviceOptions}
                                onChange={handleServiceChange}
                                isMandatoryField={true}
                                error={errors.service}
                                errorMessage={errorMessages.service}
                            />
                        </Grid>
                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Year"
                                name="Year"
                                value={year ? { label: year.toString(), value: year } : null}
                                options={[
                                    { label: `${new Date().getFullYear()}`, value: new Date().getFullYear() },
                                    { label: `${new Date().getFullYear() - 1}`, value: new Date().getFullYear() - 1 },
                                ]}
                                onChange={handleYearChange}
                                isMandatoryField={true}
                                error={errors.year}
                                errorMessage={errorMessages.year}
                            />

                        </Grid>


                    </Grid>
                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: { xs: "center", md: "end" },
                            mt: 3,
                        }}
                    >
                        <Button variant='contained' onClick={handleView}>View</Button>
                        {access?.canPrint && <Button variant='contained'
                            startIcon={<DownloadIcon />}  // Add the Download icon here
                            style={{ marginRight: '8px' }} onClick={handleDownload}>PDF</Button>}
                        <Button variant='contained' onClick={handleExcel}
                            startIcon={<InsertDriveFileIcon />}  // Add the Excel icon here
                            style={{ marginRight: '8px' }}>XLSX</Button>
                        <Button variant='outlined' onClick={handleCancel}>Close</Button>
                    </Box>
                </DefaultCard>
                <Dialog
                    open={openModal}
                    maxWidth="lg"
                    fullWidth
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        ...(isView === false && {
                            "& .MuiBackdrop-root": {
                                backgroundColor: "transparent", // Ensure backdrop is transparent
                                display: "none", // Hide the backdrop when isView is false
                            },
                            top: "-9999px", // Move dialog offscreen
                            left: "-9999px", // Move dialog offscreen
                            zIndex: "-1", // Ensure it's not clickable or visible
                        }),
                    }}
                >
                    <DialogContent>
                        <Kpirepairdownload
                            reportdata={reportdata}
                            setOpenModal={setOpenModal}
                            hospitalname={hospitalname}
                            year={year}
                            service={service}
                            ref={childRef}
                            text={text}
                            setText={setText}
                            date={date}
                            setDate={setDate}
                        />
                    </DialogContent>
                </Dialog>
            </Box>
            <CustomDialog
                open={cancelDialogOpen}
                onClose={handleCancelDialogClose}
                onConfirm={handleCancelConfirm}
                title="Cancel Confirmation"
                content="Do you want to continue?"
                cancelBtn="No"
                confirmBtn="Yes"
            />
        </>
    );
};

export default Kpirepairviewfile;
